export default __webpack_public_path__ + "static/media/m4.69f449d7.jpg";